import { NET_ID } from ".";

interface StableCoin {
  name: string;
  symbol: string;
  address: string;
  chainId: number;
  decimals: number;
  logoURI?: string;
  balance?: any;
}
type DexConfig = {
  defaultDex: string;
  list: {
    type: "dex" | "pump";
    value: string;
    name: string;
    routerAddress: string;
    factoryAddress: string;
    logo: string;
    disabled?: boolean;
  }[];
  stableCoins: StableCoin[];
};

const swapConfig: Record<number, DexConfig> = {
  // Evm Mainnet
  1: {
    defaultDex: "uniswap",
    list: [
      {
        type: "dex",
        value: "uniswap",
        name: "UniSwap V2",
        routerAddress: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
        factoryAddress: "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f",
        logo: "/img/eth/lp/uni.svg",
      },
      {
        type: "pump",
        value: "grafun",
        name: "GraFun",
        routerAddress: "",
        factoryAddress: "",
        logo: "/img/bsc/grafun-not-online.svg",
        disabled: true,
      },
    ],
    stableCoins: [
      {
        name: "USDT Stablecoin",
        symbol: "USDT",
        address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
        chainId: 1,
        decimals: 6,
        logoURI:
          "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
      },
    ],
  },
  // Evm Testnet
  11155111: {
    defaultDex: "uniswap",
    list: [
      {
        type: "dex",
        value: "uniswap",
        name: "UniSwap V2",
        routerAddress: "0xC532a74256D3Db42D0Bf7a0400fEFDbad7694008",
        factoryAddress: "0x7E0987E5b3a30e3f2828572Bb659A548460a3003",
        logo: "/img/eth/lp/uni.svg",
      },
      {
        type: "pump",
        value: "grafun",
        name: "GraFun",
        routerAddress: "",
        factoryAddress: "",
        logo: "/img/bsc/grafun-not-online.svg",
        disabled: true,
      },
    ],
    stableCoins: [
      {
        name: "USDT Stablecoin",
        symbol: "MUSDT",
        address: "0x810ecC2aa8b798F28633e1586a718cd48083Bae9",
        chainId: 1,
        decimals: 18,
        logoURI:
          "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/ethereum/assets/0xdAC17F958D2ee523a2206206994597C13D831ec7/logo.png",
      },
    ],
  },
  // Bsc Testnet
  97: {
    defaultDex: "pancake",
    list: [
      {
        type: "dex",
        value: "pancake",
        name: "PancakeSwap",
        routerAddress: "0xD99D1c33F9fC3444f8101754aBC46c52416550D1",
        factoryAddress: "0x6725F303b657a9451d8BA641348b6761A6CC7a17",
        logo: "/img/bsc/pancake.svg",
      },
      {
        type: "pump",
        value: "FourMeme",
        name: "FourMeme",
        routerAddress: "0x5c952063c7fc8610FFDB798152D69F0B9550762b",
        factoryAddress: "",
        logo: "/img/bsc/four.svg",
        // disabled: true,
      },
      // {
      //   type: "pump",
      //   value: "grafun",
      //   name: "GraFun",
      //   routerAddress: "",
      //   factoryAddress: "",
      //   logo: "/img/bsc/grafun-not-online.svg",
      //   disabled: true,
      // },
      // {
      //   type: "dex",
      //   value: "babydoge",
      //   name: "BabyDoge",
      //   routerAddress: "",
      //   factoryAddress: "",
      //   logo: "/img/bsc/babydoge-not-online.svg",
      //   disabled: true,
      // },
    ],
    stableCoins: [
      {
        name: "FAKE USDC",
        symbol: "FUSDC",
        address: "0x4516FC0De3F403343c97ed67c4Ac7E1F85AB44ef",
        chainId: 97,
        decimals: 18,
      }, // FAKE USDC
      // {
      //   name: "Dai Token",
      //   symbol: "DAI",
      //   address: "0x8a9424745056eb399fd19a0ec26a14316684e274",
      //   chainId: 97,
      //   decimals: 18
      // },
    ],
  },
  // Bsc Mainnet
  56: {
    defaultDex: "pancake",
    list: [
      {
        type: "dex",
        value: "pancake",
        name: "PancakeSwap",
        routerAddress: "0x10ED43C718714eb63d5aA57B78B54704E256024E",
        factoryAddress: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
        logo: "/img/bsc/pancake.svg",
      },
      {
        type: "pump",
        value: "FourMeme",
        name: "FourMeme",
        routerAddress: "0x5c952063c7fc8610FFDB798152D69F0B9550762b",
        factoryAddress: "",
        logo: "/img/bsc/four.svg",
        balacne: "",
        // disabled: true,
      },
      // {
      //   type: "pump",
      //   value: "grafun",
      //   name: "GraFun",
      //   routerAddress: "",
      //   factoryAddress: "",
      //   logo: "/img/bsc/grafun-not-online.svg",
      //   disabled: true,
      // },
      // {
      //   type: "dex",
      //   value: "babydoge",
      //   name: "BabyDoge",
      //   routerAddress: "",
      //   factoryAddress: "",
      //   logo: "/img/bsc/babydoge-not-online.svg",
      //   disabled: true,
      // },
    ],
    stableCoins: [
      {
        name: "Binance Pegged USDT",
        symbol: "USDT",
        address: "0x55d398326f99059fF775485246999027B3197955",
        chainId: 56,
        decimals: 18,
        logoURI:
          "https://tokens.pancakeswap.finance/images/0x55d398326f99059fF775485246999027B3197955.png",
      },
      {
        chainId: 56,
        symbol: "USD1",
        name: "World Liberty Financial USD",
        decimals: 18,
        address: "0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d",
        logoURI:
          "https://tokens.pancakeswap.finance/images/0x8d0D000Ee44948FC98c9B98A4FA4921476f08B0d.png",
      },
      {
        "chainId": 56,
        "symbol": "FIST",
        "name": "FistToken",
        "decimals": 6,
        "address": "0xC9882dEF23bc42D53895b8361D0b1EDC7570Bc6A",
        "logoURI": "https://assets.coingecko.com/coins/images/25051/thumb/download.png?1696524202"
      },
      // {
      //   name: "Binance Pegged DAI",
      //   symbol: "DAI",
      //   address: "0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3",
      //   chainId: 56,
      //   decimals: 18,
      //   logoURI:
      //     "https://tokens.pancakeswap.finance/images/0x1AF3F329e8BE154074D8769D1FFa4eE058B1DBc3.png",
      // },
      // {
      //   name: "VAI Stablecoin",
      //   symbol: "VAI",
      //   address: "0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7",
      //   chainId: 56,
      //   decimals: 18,
      //   logoURI:
      //     "https://tokens.pancakeswap.finance/images/0x4BD17003473389A42DAF6a0a729f6Fdb328BbBd7.png",
      // },
    ],
  },
  // base Sepolia
  84532: {
    defaultDex: "uniswap",
    list: [
      {
        type: "dex",
        value: "uniswap",
        name: "UniSwap V2",
        routerAddress: "0x1689E7B1F10000AE47eBfE339a4f69dECd19F602",
        factoryAddress: "0x7Ae58f10f7849cA6F5fB71b7f45CB416c9204b1e",
        logo: "/img/eth/lp/uni.svg",
      },
      // {
      //   value: "uniswapV3",
      //   name: "UniSwap V3",
      //   routerAddress: "",
      //   factoryAddress: "",
      //   logo: "/img/base/uni-grey.webp",
      //   disabled: true,
      // },

      {
        type: "pump",
        value: "virtuals",
        name: "virtuals",
        routerAddress: "",
        factoryAddress: "",
        logo: "/img/base/virtuals-grey.webp",
        disabled: true,
      },
    ],
    stableCoins: [
      {
        name: "Mock USDC",
        symbol: "MUSDC",
        address: "0xf656FA19B62BfEFFB846D206BABc2C1435c1d0B0",
        chainId: 84532,
        decimals: 6,
        logoURI: "https://basescan.org/token/images/centre-usdc_28.png",
      },
    ],
  },
  // base Mainnet
  8453: {
    defaultDex: "uniswap",
    list: [
      {
        type: "dex",
        value: "uniswap",
        name: "UniSwap V2",
        routerAddress: "0x4752ba5dbc23f44d87826276bf6fd6b1c372ad24",
        factoryAddress: "0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6",
        logo: "/img/eth/lp/uni.svg",
      },
      {
        type: "pump",
        value: "virtuals",
        name: "virtuals",
        routerAddress: "",
        factoryAddress: "",
        logo: "/img/base/virtuals-grey.webp",
        disabled: true,
      },
    ],
    stableCoins: [
      {
        name: "USDC Stablecoin",
        symbol: "USDC",
        address: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
        chainId: 8453,
        decimals: 6,
        logoURI: "https://basescan.org/token/images/centre-usdc_28.png",
      },
    ],
  },
};

/**
 * 根据链id返回swap信息
 * @returns
 */
export function getDexs() {
  const index = Number(NET_ID);
  return swapConfig[index];
}

/**
 * 根据链id和dex值返回对应的routeraddres，方便用来操作合约
 * @param netId
 * @param dexValue
 * @returns
 */
export function getRouterAddress(
  netId: number,
  dexValue: string
): string | undefined {
  const dexConfig = swapConfig[netId];

  if (!dexConfig) {
    return undefined; // 如果没有找到对应的 NET_ID，返回 undefined
  }

  const dex = dexConfig.list.find((d) => d.value === dexValue);

  return dex ? dex.routerAddress : undefined; // 如果找到了对应的 value，则返回 routerAddress，否则返回 undefined
}

export function getFactoryAddress(
  netId: number,
  dexValue: string
): string | undefined {
  const dexConfig = swapConfig[netId];

  if (!dexConfig) {
    return undefined; // 如果没有找到对应的 NET_ID，返回 undefined
  }

  const dex = dexConfig.list.find((d) => d.value === dexValue);

  return dex ? dex.factoryAddress : undefined; // 如果找到了对应的 value，则返回 routerAddress，否则返回 undefined
}
